import { asIsoCountryCode2, getDomain } from '@rbilabs/intl';

import { SupportedRegions } from '@rbi-ctg/frontend';
import { brand } from 'utils/environment';

export const isURIScheme = (url: string): boolean => {
  const u = new URL(url);
  if (!(u.protocol === 'http:' || u.protocol === 'https:')) {
    const uriParts = url.split('://');
    return uriParts && uriParts.length === 2;
  }
  return false;
};

// if the protocol is `popeyes://`
export const parseURIScheme = (url: string): string | undefined => {
  const u = new URL(url);
  if (!(u.protocol === 'http:' || u.protocol === 'https:')) {
    const uriParts = url.split('://');
    if (uriParts && uriParts.length === 2) {
      // adding a "/" to prevent routing issues for routes using slug
      return `/${uriParts[1]}`;
    }
  }
  return;
};

export const getTLD = (region: SupportedRegions) => {
  return getDomain(brand().toUpperCase(), asIsoCountryCode2(region));
};

export const replaceTLD = (
  origin: string,
  source: SupportedRegions,
  dest: SupportedRegions,
  redirectWithTLD: boolean
) => {
  const sourceTLD = getTLD(source);
  const destTLD = getTLD(dest);

  if (redirectWithTLD) {
    /*
    For popeyes.es, we need to replace with ".es" not with "es". if we do replace with "es",
    it is going to match the first "es" in the word, resulting in "popeych.es", which is incorrect
    */
    return origin.replace(new RegExp(`\\.${sourceTLD}$`), `.${destTLD}`);
  } else {
    return origin.replace(sourceTLD, destTLD);
  }
};
